import map from "lodash/map";
import get from "lodash/get";
import find from "lodash/find";
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import meanBy from "lodash/meanBy";
import flatMap from "lodash/flatMap";
import filter from "lodash/filter"
const duration = require("dayjs/plugin/duration");

dayjs.extend(isBetween);
dayjs.extend(duration);

export const minutesToDayjs = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return dayjs().hour(hours).minute(mins);
};

export const dayjsToMinutes = (timeValue) => {
    if (dayjs.isDayjs(timeValue)) {
        return timeValue.hour() * 60 + timeValue.minute();
    }
    return 0;
};

export const getTransformedMinutes = (minutes) => {
  const hours = Math.floor(minutes / 60); // Get total hours
  const mins = minutes % 60; // Get remaining minutes

  if (hours === 0 && mins === 0) {
    return "0";
  }

  const hoursText = hours > 0 ? `${hours} hrs` : "";
  const minutesText = mins > 0 ? `${mins} mins` : "";

  return [hoursText, minutesText].filter(Boolean).join(" ");
};


export const getUrl = (apiPath, params = null) => {
  let paramString = "";
  let firstParam = true;
  if (params) {
    paramString += "?";
    map(params, (value, key) => {
      if (value) {
        if (firstParam) {
          paramString += `${key}=${value}`;
          firstParam = false;
        } else {
          paramString += `&${key}=${value}`;
        }
      }
    });
  }
  return `${apiPath}${paramString}`;
};

export const getButtonDisabled = (values, keys = []) => {
  let flag = false;
  map(keys, (key) => {
    const val = get(values, `${key}`);
    if (isNull(val) || isUndefined(val)) {
      flag = true;
    }
  });
  return flag;
};

function isCurrentShift(shift) {
  const now = dayjs();
  const format = "HH:mm:ss";
  const shiftStart = dayjs(shift.start, format);
  let shiftEnd = dayjs(shift.end, format);

  if (shiftEnd.isBefore(shiftStart)) {
    shiftEnd = shiftEnd.add(1, "day");
  }

  return now.isBetween(shiftStart, shiftEnd, null, "[)");
}

export const getCurrentShift = (shiftArr) => {
  const currentShift = find(shiftArr, isCurrentShift);
  return currentShift;
};

export const replaceMultiple = (string, mapObj) => {
  const re = new RegExp(Object.keys(mapObj).join("|"), "gi");
  string = string.replace(re, (matched) => mapObj[matched]);
  return string;
};

export const getFileNameInitials = (type, config) => {
  let  { tempalteName, shiftName, companyName, date } = config;
  
  switch (type) {
    case "time-graph":
      tempalteName = tempalteName.split(" ");
      let name = `${get(tempalteName, "0.0")}_`;
      name = `${name}${get(tempalteName, "1.0", "")}_${get(
        shiftName,
        "0"
      )}_${companyName}_${date.format("DD-MM-YYYY")}`;
      return `${name}.pdf`;

    case "day-graph":
      tempalteName = tempalteName.split(" ");
      let tname = `${get(tempalteName, "0.0")}_`;
      tname = `${tname}${get(
        tempalteName,
        "1.0",
        ""
      )}_${companyName}_${dayjs(date[0],'YYYY-MM-DD').format("DD-MM-YYYY")}_${dayjs(date[0],'YYYY-MM-DD').format(
        "DD-MM-YYYY"
      )}`;
      return `${tname}.pdf`;
  }
};

export const getDownloadFileName = (type, data) => {
  switch (type) {
    case "time-summary-report":
      return `Time_summary_${get(data, "date")}.pdf`;
    case "job-card":
      return `Job_Card_${get(data, "date")}.pdf`
    case "day-summary-report":
      return `day_summary_${get(data, "from_date")}_${get(
        data,
        "to_date"
      )}.pdf`;
    case "operator-detail-report":
      return `${get(data, "operator_name")}_detail_${get(data, "date")}.pdf`;
    case "operator-summary-report":
      return `Operator_summary_${get(data, "date")}.pdf`;
    case "part-summary-report":
      return `Part_summary_${get(data, "date")}.pdf`;
    case "part-detail-report":
      return `${get(data, "part_name")}_detail_${get(data, "date")}.pdf`;
    case "performance-report":
      return `${get(data, "template_name")}_performance_${get(
        data,
        "date"
      )}.pdf`;
  }
};

export const getDownloadExcelFileName = (type, data) => {
  switch (type) {
    case "PNL":
      return `PNL_Summary_Report_${get(data,"date")}.xlsx`
    case "time":
      return `Time_Summary_Report_${get(data,"date")}.xlsx`
    case "time-summary-report":
      return `Day_Detail_Report_${get(data, "from_date")}_${get(
        data,
        "to_date"
      )}.xlsx`;
    case "day-summary-report":
      return `Multi_Day_Report_${get(data, "from_date")}_${get(
        data,
        "to_date"
      )}.xlsx`;
  }
};


export const checkNullable = (value, defaultVal = 0) => {
  return isNull(value) ? defaultVal : value;
};

export function convertTimeRangeToAmPm(timeRange24Hr) {
  if (!timeRange24Hr || typeof timeRange24Hr !== 'string' || !timeRange24Hr.includes('-')) {
    console.error("Invalid input: Please provide a time range string in 'HH:mm-HH:mm' format.");
    return null;
  }

  const [startTimeStr, endTimeStr] = timeRange24Hr.split('-');

  const startTime = dayjs(startTimeStr, 'HH:mm');
  const endTime = dayjs(endTimeStr, 'HH:mm');

  if (!startTime.isValid() || !endTime.isValid()) {
    console.error(`Error parsing time range '${timeRange24Hr}'. Make sure times are in HH:mm format.`);
    return null;
  }

  const formattedStartTime = startTime.format('h:mm A');
  const formattedEndTime = endTime.format('h:mm A');

  return `${formattedStartTime}-${formattedEndTime}`;
}

export const calculateMeanEfficiency = (machinesSummary, metricPath) => {
  if (!Array.isArray(machinesSummary) || machinesSummary.length === 0) return 0;

  const allShifts = flatMap(machinesSummary, (m) => m.shifts || []);

  const validShifts = filter(allShifts,(shift) => {
    const val = get(shift, metricPath);
    return val != null && val === 0;
  });

  const avg = meanBy(validShifts, (shift) => get(shift, metricPath, 0));

  return avg || 0;
};

export function getTimeDifference(startTime, endTime) {
  const toSeconds = (t) => {
    const [h, m, s] = t.split(":").map(Number);
    return h * 3600 + m * 60 + s;
  };
  let start = toSeconds(startTime);
  let end = toSeconds(endTime);
  if (end < start) {
    end += 24 * 3600;
  }

  const diff = end - start;
  const decimalHours = diff / 3600;
  return Number(decimalHours.toFixed(2));
}

export const normalize = (value) =>
    value == null || value < 0 ? 0 : Number(value);

export function safeAdd(a, b) {
  return normalize(a) + normalize(b);
}